import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from './en.json';
import de from './de.json';
import pl from './pl.json';
import bg from './bg.json';
import fr from './fr.json';
import nl from './nl.json';

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: "de",
    debug: false,
    returnObjects: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: en,
      },
      de: {
        translation: de,
      },
      pl: {
        translation: pl,
      },
      bg: {
        translation: bg,
      },
      fr: {
        translation: fr,
      },
      nl: {
        translation: nl,
      },
    },
});
